import {
    HTMLAttributes,
    ReactElement
} from "react";
import { Button } from ".";
import { ProfilePic } from "../../assets";
interface Props extends HTMLAttributes<HTMLElement> {
    image: string;
    name: string;
    position?: string;
    isMini?: boolean;
    email?: string;
    details?: string;
    myStyle?: string;
}
export function ProfileCard({ image, name, position, details , isMini , myStyle , email}: Props): ReactElement {
    return (
        <div className={`${myStyle && myStyle} profile-card`}>
                {/* <img alt="هامرز" src={`${AppConstants.base_url_download}${image}`  || ProfilePic} className={`${isMini && "mini-img"}`} alt="هامرز" /> */}
                <img src={ProfilePic} className={`${isMini && "mini-img"}`} alt="هامرز" />

                <div className="d-flex flex-column me-2">
                    <span className={`${isMini &&  "mini-name" } name`}>
                        {name}
                    </span>
                    {email && 
                    <span className="hide-desktop">
                        {email}
                    </span>
                    }
                    {details && 
                    <span className="details">
                        {details}
                    </span>
                    }
                    {position &&
                        <Button myStyle="bg-green shadow-btn" title={position} />
                    }
                </div>
        </div>
    )
}
export default ProfileCard;


